export class BaseController {
    constructor(view) {
        this.view = view;
        this.api = view.props.api;
        this.lang = view.props.lang;
        this.sessionManager = view.props.sessionManager;
    }
}
